import { AppUserDayValidationRuleEnum, AppUserDayViewModel } from '@/services/api/nswag/stapiclient_generated';

export function GetTeamOverviewApprovalIcon(day: AppUserDayViewModel, enums: AppUserDayValidationRuleEnum[]) {
  const warnings = day.violatedValidationRules.filter((x) => enums.includes(x.ruleEnum));
  if (!warnings.length) {
    return null;
  }

  return warnings.map((x) => x.ruleDescription).join('<br><br>');
}

export const PauseWarningEnums = [AppUserDayValidationRuleEnum.PauseRuleViolated, AppUserDayValidationRuleEnum.PauseValidationNotPossible];
export const FreeDayWarningEnums = [
  AppUserDayValidationRuleEnum.TimeEntriesOnFreeDay,
  AppUserDayValidationRuleEnum.TimeEntriesOnSundayOrPublicHoliday,
  AppUserDayValidationRuleEnum.TimeEntriesOnAbsenceDay,
];

export const DailyWorkTimeWarningEnums = [
  AppUserDayValidationRuleEnum.MaxDailyHoursExceeded,
  AppUserDayValidationRuleEnum.RestTimeUndershot,
  AppUserDayValidationRuleEnum.RestTimeValidationNotPossible,
];

export const TimeEntryWarningEnums = [AppUserDayValidationRuleEnum.NoTimeEntries, AppUserDayValidationRuleEnum.ConflictingTimeEntries];

export const NotCriticalWarningEnums = [AppUserDayValidationRuleEnum.NoTimeEntries];
